module.exports = __webpack_public_path__ + "static/media/sustainability.6653ff22.png";